/**
 * Shared constants for the "update-required" forced subscription-fix flow.
 *
 * Background: a batch of subscriptions were created without a proper calorie
 * recalculation / product assignment. Affected subscriptions are flagged by the
 * backend with `isUpdateRequired`. While the flag is set we nudge the customer —
 * first with a blocking intro modal, then with a persistent banner — to re-run
 * the calculation and swap their subscription line to the corrected product.
 */

// Fired when the customer dismisses the intro modal without updating, so the
// persistent banner can reveal itself immediately (same pattern as the
// puppy→adult transition flow).
export const PET_UPDATE_REQUIRED_DISMISSED_EVENT = 'pet-update-required-dismissed';

// Fired once the corrective update succeeds, so every mounted instance
// (intro modal + banner) hides itself without waiting for a customer refetch.
export const PET_UPDATE_REQUIRED_COMPLETED_EVENT = 'pet-update-required-completed';

export const getDismissedStorageKey = (subscriptionId: number | string): string =>
  `pet_update_required_dismissed_${subscriptionId}`;

export const getCompletedStorageKey = (subscriptionId: number | string): string =>
  `pet_update_required_completed_${subscriptionId}`;
